export default __webpack_public_path__ + "478eddd3abf38d8cbd5ec8268a6fad3e.jpg";